import {
  AdjustOutlined,
  Copyright,
  DashboardOutlined,
  Handshake,
  Home,
  Notes,
  Numbers,
  PendingOutlined,
  RefreshOutlined,
  RemoveRedEye,
} from "@mui/icons-material";
import { Card, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Badge, Button, ButtonGroup, ListGroup, Modal } from "react-bootstrap";
import { BeatLoader } from "react-spinners";
import CalendarOfHearings from "../../components/CalendarOfHearings";
import ReusableTable from "../../components/custom/data_table/ReusableTable";
import IconBreadcrumbs from "../../components/custom/IconBreadcrumbs";
import { useAuthorized } from "../../hooks/useAuthorized";
import {
  useGetCertificateEndorseCountGroupCategoryQuery,
  useGetCurrentActivitiesQuery,
  useGetDashboardApplicationReportQuery,
  useGetLeftMenuCountQuery,
  useGetStatisticsAtAGlanceQuery,
} from "../../redux/api/dashboardApiSlice";
import {
  useGetActivityCountHistoryQuery,
  useLazyGetFileActivityByTypeQuery,
} from "../../redux/api/reportApiSlice";
import { theme } from "../../theme";
import { accessRoles } from "../../utils/accessRoles";
import { convertToBanglaNumerals } from "../../utils/convertToBanglaNumerals";
import { globalDateFormat, localDateFormat } from "../../utils/dateFormat";
import BanglaCalender from "../frontend/userPanel/form_two/BanglaCalender";

const Dashboard = () => {
  const [showTodayActivity, setShowTodayActivity] = useState(false);
  const { hasRole } = useAuthorized();
  const breadcrumbsData = [
    { icon: Home, title: "হোম" },
    { icon: DashboardOutlined, title: "ড্যাশবোর্ড", active: true },
  ];

  const [page, setPage] = useState(1);

  const { data, isLoading, refetch, isFetching } =
    useGetActivityCountHistoryQuery({});

  const [date, setDate] = useState("");
  const [dateTodayActivity, setDateTodayActivity] = useState(
    globalDateFormat(new Date())
  );
  const [typeTodayActivity, setTypeTodayActivity] = useState("");

  const { data: menuCont, isLoading: isLoadingMenu } =
    useGetLeftMenuCountQuery();

  const [
    findFileActivityCount,
    {
      isLoading: isLoadingFileCount,
      isFetching: isFetchingFileCounToday,
      data: dataFileCountToday,
    },
  ] = useLazyGetFileActivityByTypeQuery();

  // First call: with only the date parameter
  const {
    data: dateData,
    error: dateError,
    isLoading: isDateLoading,
    refetch: dateRefetch,
    isFetching: isFilterFetching,
  } = useGetDashboardApplicationReportQuery({ date, filter: "" });

  // Second call: with both filter and date
  const {
    data: filteredData,
    error: filterError,
    isLoading: isFilterLoading,
    refetch: filterRefetch,
    isFetching: isFilterDateFetching,
  } = useGetDashboardApplicationReportQuery({ date, filter: "month" });

  const {
    data: currentActivitiesData,
    error: currentActivitiesError,
    isLoading: isCurrentActivitiesLoading,
    refetch: currentActivitiesRefetch,
    isFetching: isCurrentActivitiesFetching,
  } = useGetCurrentActivitiesQuery();

  const {
    data: certificateEndorseCountData,
    error: certificateEndorseCountError,
    isLoading: isCertificateEndorseCountLoading,
    refetch: certificateEndorseCountRefetch,
    isFetching: isCertificateEndorseCountFetching,
  } = useGetCertificateEndorseCountGroupCategoryQuery();

  const {
    data: statisticsData,
    error: statisticsError,
    isLoading: isStatisticsLoading,
    refetch: statisticsRefetch,
    isFetching: isStatisticsFetching,
  } = useGetStatisticsAtAGlanceQuery();
  const statistics = statisticsData?.data;

  const ajkerKarjokrom =
    data?.data?.total?.sent_files +
    data?.data?.total?.received_files +
    data?.data?.total?.draft_files;

  const fetchFileActivityByType = async (type) => {
    setShowTodayActivity(true);
    setTypeTodayActivity(type);
  };

  const totalData = dataFileCountToday?.meta?.total;
  const lastPage = dataFileCountToday?.meta?.last_page;

  const handlePageChange = (page) => {
    setPage(page);
  };

  const columns = [
    { label: "তারিখ", name: "date" },

    {
      label: "ট্র্যাকিং নাম্বার",
      name: "trackReg",
    },

    {
      label: "হইতে",
      name: "from",
      options: {
        customBodyRender: (value, tableMeta) => {
          const rowItem = tableMeta.rowData?.item;
          return (
            <div>
              <label className="text-primary cursor-pointer">
                {rowItem?.sendFrom?.name}
              </label>
              <p className="m-0">{rowItem?.sendFrom?.role?.bn_name}</p>
              <p className="m-0">{rowItem?.fromStatus}</p>
            </div>
          );
        },
      },
    },
    {
      label: "প্রতি",
      name: "to",
      options: {
        customBodyRender: (value, tableMeta) => {
          const rowItem = tableMeta.rowData?.item;
          return (
            <div>
              <label className="text-primary cursor-pointer">
                {rowItem?.sendTo?.name}
              </label>
              <p className="m-0">{rowItem?.sendTo?.role?.bn_name}</p>
              <p className="m-0">{rowItem?.toStatus}</p>
            </div>
          );
        },
      },
    },
  ];

  const dataTable = dataFileCountToday?.data.map((item, i) => ({
    id: item?.id,
    date: localDateFormat(item?.date),
    trackReg: item?.profile?.trackReg,
    item: item,
  }));

  const handleDateChange = (d) => {
    setPage(1);
    setDateTodayActivity(globalDateFormat(d));
  };

  useEffect(() => {
    findFileActivityCount({ type: typeTodayActivity, date: dateTodayActivity });
  }, [dateTodayActivity, typeTodayActivity, page]);

  return (
    <>
      <div className="py-3">
        <IconBreadcrumbs breadcrumbs={breadcrumbsData} />
      </div>
      {menuCont?.data?.length ? (
        <div className="slideUp dashboard-layout  px-3 pt-3 pb-1 mb-3">
          <h6 className="fw-bold">
            <Notes sx={{ fontSize: "18px" }} /> আবেদনের আবস্থান ও সংখ্যা
          </h6>
          <div className="row">
            {menuCont?.data?.map((item, index) => (
              <div key={index} className="col-md-3 mb-2">
                <div className="border px-3 py-2 rounded d-flex align-content-center justify-content-between">
                  <Typography fontWeight={"bold"}>{item.statusName}</Typography>
                  <div>
                    <Badge variant="primary">{item.total}</Badge>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        ""
      )}
      <Grid container spacing={1.5}>
        <Grid item xs={12} md={6}>
          <div className=" slideUp h-100">
            <Card
              sx={{
                boxShadow: theme.palette.boxShadow,
                padding: "10px",
                borderRadius: "10px",
                position: "relative",
                width: "100%",
                height: "100%",
                bgcolor: "#ffffff",
              }}
            >
              <div className="p-3">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-1">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div>
                          <h6 className="fw-bold">
                            <Notes sx={{ fontSize: "18px" }} /> আজকের কার্যক্রম
                          </h6>
                          <small>
                            <AdjustOutlined
                              sx={{
                                fontSize: "17px",
                                mr: "7px",
                              }}
                            />{" "}
                            মোট কার্যক্রম -{" "}
                            {ajkerKarjokrom
                              ? convertToBanglaNumerals(ajkerKarjokrom)
                              : convertToBanglaNumerals(0)}{" "}
                            টি
                          </small>
                        </div>
                        <div>
                          <Button size="sm" onClick={() => refetch()}>
                            <RefreshOutlined />
                          </Button>
                        </div>
                      </div>
                      <ListGroup as="ol">
                        <ListGroup.Item
                          as="li"
                          className="d-flex justify-content-between align-items-start cursor-pointer"
                          onClick={() => fetchFileActivityByType(1)}
                        >
                          <div className="ms-2 me-auto">
                            <label>প্রেরিত নথি</label>
                          </div>
                          <RemoveRedEye />
                        </ListGroup.Item>
                        <ListGroup.Item
                          as="li"
                          className="d-flex justify-content-between align-items-start  cursor-pointer"
                          onClick={() => fetchFileActivityByType(2)}
                        >
                          <div className="ms-2 me-auto">
                            <label>প্রাপ্ত নথি</label>
                          </div>
                          <RemoveRedEye />
                        </ListGroup.Item>

                        <ListGroup.Item
                          as="li"
                          className="d-flex justify-content-between align-items-start cursor-pointer"
                          onClick={() => fetchFileActivityByType(3)}
                        >
                          <div className="ms-2 me-auto">
                            <label>সংরক্ষিত নথি</label>
                          </div>
                          <RemoveRedEye />
                        </ListGroup.Item>
                      </ListGroup>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <div className=" slideUp h-100">
            <Card
              sx={{
                boxShadow: theme.palette.boxShadow,
                padding: "10px",
                borderRadius: "10px",
                position: "relative",
                width: "100%",
                height: "100%",
                bgcolor: "#ffffff",
              }}
            >
              {isDateLoading || isFilterFetching ? (
                <div className="text-center">
                  <BeatLoader />
                </div>
              ) : (
                <div className="p-3">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-1">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <div>
                            <h6 className="fw-bold">
                              <Notes sx={{ fontSize: "18px" }} /> আজকের আবেদন
                            </h6>
                            <small>
                              <AdjustOutlined
                                sx={{
                                  fontSize: "17px",
                                  mr: "7px",
                                }}
                              />{" "}
                              মোট আবেদন -{" "}
                              {convertToBanglaNumerals(
                                dateData?.data?.grandTotalApplications
                              )}{" "}
                              টি
                            </small>
                            <small>
                              {" "}
                              <PendingOutlined
                                sx={{
                                  fontSize: "17px",
                                  mx: "7px",
                                }}
                              />{" "}
                              মোট শাখা -{" "}
                              {convertToBanglaNumerals(
                                dateData?.data?.categoriesData?.length
                              )}{" "}
                              টি
                            </small>
                          </div>
                          <div>
                            <Button size="sm" onClick={() => dateRefetch()}>
                              <RefreshOutlined />
                            </Button>
                          </div>
                        </div>
                        <ListGroup as="ol">
                          {Array.isArray(dateData?.data?.categoriesData) &&
                            dateData.data.categoriesData.map((item) => (
                              <ListGroup.Item
                                as="li"
                                className="d-flex justify-content-between align-items-start"
                                key={item?.id || item?.categoryName} // Add a unique key
                              >
                                <div className="ms-2 me-auto">
                                  <label>{item?.name}</label>
                                  <div>
                                    মোট{" "}
                                    {convertToBanglaNumerals(
                                      item?.totalApplications
                                    )}{" "}
                                    টি
                                  </div>
                                </div>
                                <div>
                                  <div>
                                    <Copyright
                                      sx={{
                                        fontSize: "17px",
                                        mr: "10px",
                                      }}
                                    />
                                    {convertToBanglaNumerals(
                                      item?.totalCopyright
                                    )}{" "}
                                    টি
                                  </div>
                                  <div>
                                    <Handshake
                                      sx={{
                                        fontSize: "17px",
                                        mr: "10px",
                                      }}
                                    />
                                    {convertToBanglaNumerals(
                                      item?.totalAgreement
                                    )}{" "}
                                    টি
                                  </div>
                                </div>
                              </ListGroup.Item>
                            ))}
                        </ListGroup>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Card>
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <div className=" slideUp h-100">
            <Card
              sx={{
                boxShadow: theme.palette.boxShadow,
                padding: "10px",
                borderRadius: "10px",
                position: "relative",
                width: "100%",
                height: "100%",
                bgcolor: "#ffffff",
              }}
            >
              {isFilterLoading || isFilterDateFetching ? (
                <div className="text-center">
                  <BeatLoader />
                </div>
              ) : (
                <div className="p-3">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-1">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <div>
                            <h6 className="fw-bold">
                              <Notes sx={{ fontSize: "18px" }} /> এ মাসের আবেদন
                            </h6>
                            <small>
                              <AdjustOutlined
                                sx={{
                                  fontSize: "17px",
                                  mr: "7px",
                                }}
                              />{" "}
                              মোট আবেদন -{" "}
                              {convertToBanglaNumerals(
                                filteredData?.data?.grandTotalApplications
                              )}{" "}
                              টি{" ,"}
                            </small>
                            <small>
                              <PendingOutlined
                                sx={{
                                  fontSize: "17px",
                                  mx: "7px",
                                }}
                              />{" "}
                              মোট শাখা -{" "}
                              {convertToBanglaNumerals(
                                filteredData?.data?.categoriesData?.length
                              )}{" "}
                              টি
                            </small>
                          </div>
                          <div>
                            <Button size="sm" onClick={() => filterRefetch()}>
                              <RefreshOutlined />
                            </Button>
                          </div>
                        </div>
                        <ListGroup as="ol">
                          {Array.isArray(filteredData?.data?.categoriesData) &&
                            filteredData.data.categoriesData.map((item) => (
                              <ListGroup.Item
                                as="li"
                                className="d-flex justify-content-between align-items-start"
                                key={item?.id || item?.categoryName} // Add a unique key
                              >
                                <div className="ms-2 me-auto">
                                  <label>{item?.name}</label>
                                  <div>
                                    মোট{" "}
                                    {convertToBanglaNumerals(
                                      item?.totalApplications
                                    )}{" "}
                                    টি
                                  </div>
                                </div>
                                <div>
                                  <div>
                                    <Copyright
                                      sx={{
                                        fontSize: "17px",
                                        mr: "10px",
                                      }}
                                    />
                                    {convertToBanglaNumerals(
                                      item?.totalCopyright
                                    )}{" "}
                                    টি
                                  </div>
                                  <div>
                                    <Handshake
                                      sx={{
                                        fontSize: "17px",
                                        mr: "10px",
                                      }}
                                    />
                                    {convertToBanglaNumerals(
                                      item?.totalAgreement
                                    )}{" "}
                                    টি
                                  </div>
                                </div>
                              </ListGroup.Item>
                            ))}
                        </ListGroup>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Card>
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <div className=" slideUp h-100">
            <Card
              sx={{
                boxShadow: theme.palette.boxShadow,
                padding: "10px",
                borderRadius: "10px",
                position: "relative",
                width: "100%",
                height: "100%",
                bgcolor: "#ffffff",
              }}
            >
              {isCertificateEndorseCountFetching ||
              isCertificateEndorseCountLoading ? (
                <div className="text-center">
                  <BeatLoader />
                </div>
              ) : (
                <div className="p-3">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-1">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <div>
                            <h6 className="fw-bold">
                              <Notes sx={{ fontSize: "18px" }} /> এ মাসের
                              সার্টিফিকেট প্রদান
                            </h6>
                            <small>
                              <AdjustOutlined
                                sx={{
                                  fontSize: "17px",
                                  mr: "7px",
                                }}
                              />{" "}
                              মোট আবেদন -{" "}
                              {convertToBanglaNumerals(
                                certificateEndorseCountData?.data
                                  ?.grandTotalCertificateEndorse
                              )}{" "}
                              টি
                            </small>
                          </div>
                          <div>
                            <Button
                              size="sm"
                              onClick={() => certificateEndorseCountRefetch()}
                            >
                              <RefreshOutlined />
                            </Button>
                          </div>
                        </div>
                        <ListGroup as="ol">
                          <ListGroup as="ol">
                            {Array.isArray(
                              certificateEndorseCountData?.data?.categoriesData
                            ) &&
                              certificateEndorseCountData.data.categoriesData.map(
                                (item) => (
                                  <ListGroup.Item
                                    as="li"
                                    className="d-flex justify-content-between align-items-start"
                                    key={item?.id || item?.categoryName} // Add a unique key
                                  >
                                    <div className="ms-2 me-auto">
                                      <label>{item?.name}</label>
                                      <div>
                                        মোট{" "}
                                        {convertToBanglaNumerals(
                                          item?.totalCertificateEndorse
                                        )}{" "}
                                        টি
                                      </div>
                                    </div>
                                    <div>
                                      <div>
                                        <Copyright
                                          sx={{
                                            fontSize: "17px",
                                            mr: "10px",
                                          }}
                                        />
                                        {convertToBanglaNumerals(
                                          item?.totalCertificate
                                        )}{" "}
                                        টি
                                      </div>
                                      <div>
                                        <Handshake
                                          sx={{
                                            fontSize: "17px",
                                            mr: "10px",
                                          }}
                                        />
                                        {convertToBanglaNumerals(
                                          item?.totalEndorse
                                        )}{" "}
                                        টি
                                      </div>
                                    </div>
                                  </ListGroup.Item>
                                )
                              )}
                          </ListGroup>
                        </ListGroup>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Card>
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <div className=" slideUp h-100">
            <Card
              sx={{
                boxShadow: theme.palette.boxShadow,
                padding: "10px",
                borderRadius: "10px",
                position: "relative",
                width: "100%",
                height: "100%",
                bgcolor: "#ffffff",
              }}
            >
              {isCurrentActivitiesLoading || isCurrentActivitiesFetching ? (
                <div className="text-center">
                  <BeatLoader />
                </div>
              ) : (
                <div className="p-3">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-1">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <div>
                            <h6 className="fw-bold">
                              <Notes sx={{ fontSize: "18px" }} /> বর্তমান
                              কার্যক্রম
                            </h6>
                            <small>
                              <AdjustOutlined
                                sx={{
                                  fontSize: "17px",
                                  mr: "7px",
                                }}
                              />{" "}
                              মোট আবেদন -{" "}
                              {convertToBanglaNumerals(
                                currentActivitiesData?.data
                                  ?.grandTotalApplications
                              )}{" "}
                              টি
                            </small>
                          </div>
                          <div>
                            <Button
                              size="sm"
                              onClick={() => currentActivitiesRefetch()}
                            >
                              <RefreshOutlined />
                            </Button>
                          </div>
                        </div>
                        <ListGroup as="ol">
                          {Array.isArray(
                            currentActivitiesData?.data?.rolesData
                          ) &&
                            currentActivitiesData.data.rolesData.map((item) => (
                              <ListGroup.Item
                                as="li"
                                className="d-flex justify-content-between align-items-start"
                                key={item?.roleName} // Add a unique key
                              >
                                <div className="ms-2 me-auto">
                                  <label>{item?.roleName}</label>
                                </div>
                                <div>
                                  <div>
                                    <Numbers
                                      sx={{
                                        fontSize: "17px",
                                        mr: "10px",
                                      }}
                                    />
                                    {convertToBanglaNumerals(
                                      item?.totalApplications
                                    )}{" "}
                                    টি
                                  </div>
                                </div>
                              </ListGroup.Item>
                            ))}
                        </ListGroup>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Card>
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <div className=" slideUp h-100">
            <Card
              sx={{
                boxShadow: theme.palette.boxShadow,
                padding: "10px",
                borderRadius: "10px",
                position: "relative",
                width: "100%",
                height: "100%",
                bgcolor: "#ffffff",
              }}
            >
              {isStatisticsFetching || isStatisticsLoading ? (
                <div className="text-center">
                  <BeatLoader />
                </div>
              ) : (
                <div className="p-3">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-1">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <div>
                            <h6 className="fw-bold">
                              <Notes sx={{ fontSize: "18px" }} /> পরিসংখ্যান
                            </h6>
                            <small>
                              <AdjustOutlined
                                sx={{
                                  fontSize: "17px",
                                  mr: "7px",
                                }}
                              />{" "}
                              মোট আবেদন -{" "}
                              {convertToBanglaNumerals(
                                statistics?.[0]?.grandTotal
                              )}{" "}
                              টি
                            </small>
                          </div>
                          <div>
                            <Button
                              size="sm"
                              onClick={() => statisticsRefetch()}
                            >
                              <RefreshOutlined />
                            </Button>
                          </div>
                        </div>
                        <ListGroup as="ol">
                          <ListGroup.Item
                            as="li"
                            className="d-flex justify-content-between align-items-start"
                          >
                            <div className="ms-2 me-auto">
                              <label>নতুন আবেদন</label>
                            </div>
                            <div>
                              <div>
                                <Numbers
                                  sx={{
                                    fontSize: "17px",
                                    mr: "10px",
                                  }}
                                />{" "}
                                {convertToBanglaNumerals(
                                  statistics?.[0]?.totalNewApplication
                                )}{" "}
                                টি
                              </div>
                            </div>
                          </ListGroup.Item>
                          <ListGroup.Item
                            as="li"
                            className="d-flex justify-content-between align-items-start"
                          >
                            <div className="ms-2 me-auto">
                              <label>প্রক্রিয়াধীন </label>
                            </div>
                            <div>
                              <div>
                                <Numbers
                                  sx={{
                                    fontSize: "17px",
                                    mr: "10px",
                                  }}
                                />{" "}
                                {convertToBanglaNumerals(
                                  statistics?.[0]?.totalProcessing
                                )}{" "}
                                টি
                              </div>
                            </div>
                          </ListGroup.Item>
                          <ListGroup.Item
                            as="li"
                            className="d-flex justify-content-between align-items-start"
                          >
                            <div className="ms-2 me-auto">
                              <label>চূরান্তভাবে অনুমোদিত </label>
                            </div>
                            <div>
                              <div>
                                <Numbers
                                  sx={{
                                    fontSize: "17px",
                                    mr: "10px",
                                  }}
                                />{" "}
                                {convertToBanglaNumerals(
                                  statistics?.[0]?.totalAuthorized
                                )}{" "}
                                টি
                              </div>
                            </div>
                          </ListGroup.Item>
                          <ListGroup.Item
                            as="li"
                            className="d-flex justify-content-between align-items-start"
                          >
                            <div className="ms-2 me-auto">
                              <label>চূরান্তভাবে অননুমোদিত </label>
                            </div>
                            <div>
                              <div>
                                <Numbers
                                  sx={{
                                    fontSize: "17px",
                                    mr: "10px",
                                  }}
                                />{" "}
                                {convertToBanglaNumerals(
                                  statistics?.[0]?.totalUnauthorized
                                )}{" "}
                                টি
                              </div>
                            </div>
                          </ListGroup.Item>
                          <ListGroup.Item
                            as="li"
                            className="d-flex justify-content-between align-items-start"
                          >
                            <div className="ms-2 me-auto">
                              <label>সার্টিফিকেট প্রদান</label>
                            </div>
                            <div>
                              <div>
                                <Numbers
                                  sx={{
                                    fontSize: "17px",
                                    mr: "10px",
                                  }}
                                />{" "}
                                {convertToBanglaNumerals(
                                  Number(statistics?.[0]?.totalCertEndsIssued) -
                                    Number(
                                      statistics?.[0]?.totalCertEndsCanceled
                                    )
                                )}{" "}
                                টি
                              </div>
                            </div>
                          </ListGroup.Item>
                          <ListGroup.Item
                            as="li"
                            className="d-flex justify-content-between align-items-start"
                          >
                            <div className="ms-2 me-auto">
                              <label>নথিজাত</label>
                            </div>
                            <div>
                              <div>
                                <Numbers
                                  sx={{
                                    fontSize: "17px",
                                    mr: "10px",
                                  }}
                                />{" "}
                                {convertToBanglaNumerals(
                                  statistics?.[0]?.totalRecorded
                                )}{" "}
                                টি
                              </div>
                            </div>
                          </ListGroup.Item>
                        </ListGroup>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Card>
          </div>
        </Grid>
        {hasRole([
          accessRoles.CopyrightAdmin,
          accessRoles.Register,
          accessRoles.DeputyRegister,
        ]) && (
          <Grid item xs={12}>
            <div className=" slideUp h-100">
              <Card
                sx={{
                  boxShadow: theme.palette.boxShadow,
                  padding: "10px",
                  borderRadius: "10px",
                  position: "relative",
                  width: "100%",
                  height: "100%",
                  bgcolor: "#ffffff",
                }}
              >
                <CalendarOfHearings />
              </Card>
            </div>
          </Grid>
        )}
      </Grid>

      {showTodayActivity && (
        <Modal
          show={showTodayActivity}
          onHide={() => {
            setShowTodayActivity(false);
          }}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title className="fs-5 fw-semibold">
              {Number(typeTodayActivity) === 1
                ? "প্রেরিত নথি"
                : Number(typeTodayActivity) === 2
                ? "প্রাপ্ত নথি"
                : Number(typeTodayActivity) === 3
                ? "সংরক্ষিত নথি"
                : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex gap-3 align-items-center mb-3">
              <BanglaCalender
                placeholder={"তারিখ"}
                value={dateTodayActivity || null}
                onChange={handleDateChange}
              />

              <ButtonGroup aria-label="Basic example">
                <Button
                  variant={
                    1 === Number(typeTodayActivity)
                      ? "primary"
                      : "outline-primary"
                  }
                  onClick={() => fetchFileActivityByType(1)}
                >
                  প্রেরিত নথি
                </Button>
                <Button
                  variant={
                    2 === Number(typeTodayActivity)
                      ? "primary"
                      : "outline-primary"
                  }
                  onClick={() => fetchFileActivityByType(2)}
                >
                  প্রাপ্ত নথি
                </Button>
                <Button
                  variant={
                    3 === Number(typeTodayActivity)
                      ? "primary"
                      : "outline-primary"
                  }
                  onClick={() => fetchFileActivityByType(3)}
                >
                  সংরক্ষিত নথি
                </Button>
              </ButtonGroup>
            </div>
            {isLoadingFileCount || isFetchingFileCounToday ? (
              <div className="text-center">
                <BeatLoader />
              </div>
            ) : (
              <div className="">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-1">
                      <ReusableTable
                        title={
                          dateTodayActivity
                            ? `${localDateFormat(
                                dateTodayActivity
                              )} তারিখের কার্যক্রম`
                            : "আজকের কার্যক্রম"
                        }
                        columns={columns}
                        data={dataTable}
                        isLoading={isLoadingFileCount}
                        currentPage={page}
                        lastPage={lastPage}
                        totalData={totalData}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default Dashboard;
